import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Configuration } from "../../assets/Configuration";
import { RegistrationLinkCreationAndUpdateModel } from '../models/registration-link/registration-link-creation-and-update.model';
import { RegistrationLinkModel } from '../models/registration-link/registration-link.model';
import { RegistrationLinkFullModel } from '../models/registration-link/registration-link-full.model';

@Injectable({
  providedIn: 'root'
})
export class RegistrationLinkService {

  constructor(private httpClient: HttpClient) {
  }

  public getAllRegistrationLinksFull(): Observable<RegistrationLinkFullModel[]> {
    return this.httpClient.get<RegistrationLinkFullModel[]>(Configuration.getApiBaseUrl() + "/registrationlink/full");
  }
    
  public getAllRegistrationLinks(): Observable<RegistrationLinkModel[]> {
    return this.httpClient.get<RegistrationLinkModel[]>(Configuration.getApiBaseUrl() + "/registrationlink/");
  }

  public getRegistrationLinkFull(id: string): Observable<RegistrationLinkFullModel> {
    return this.httpClient.get<RegistrationLinkFullModel>(Configuration.getApiBaseUrl() + "/registrationlink/" + id + "/full");
  }

  public addRegistrationLink(model: RegistrationLinkCreationAndUpdateModel): Observable<RegistrationLinkFullModel> {
    return this.httpClient.post<RegistrationLinkFullModel>(Configuration.getApiBaseUrl() + "/registrationlink/", model);
  }

  public updateRegistrationLink(id: string, model: RegistrationLinkCreationAndUpdateModel): Observable<RegistrationLinkFullModel> {
    return this.httpClient.post<RegistrationLinkFullModel>(Configuration.getApiBaseUrl() + "/registrationlink/" + id, model);
  }

  public deleteRegistrationLink(id: string): Observable<Object> {
    return this.httpClient.delete(Configuration.getApiBaseUrl() + "/registrationlink/" + id);
  }
}